import React, {
	memo,
	useCallback
} from 'react';
import PropTypes from 'prop-types';
import { Input } from 'semantic-ui-react';

const DefaultColumnFilter = ( {
	column: {
		filterValue,
		id,
		setFilter,
		setTableState
	}
} ) => {
	const handleChange = useCallback( ( e, { value } ) => {
		setTableState
			? setTableState( prev => {
				const filters = prev.filters.filter( col => col.id !== id );

				return {
					...prev,
					filters: value
						? [
							...filters,
							{ id, value }
						]
						: filters
				};
			} )
			: setFilter( value || [] );
	}, [
		id,
		setFilter,
		setTableState
	] );

	return (
		<>
			<Input
				fluid
				onChange={ handleChange }
				size="mini"
				value={ filterValue || '' }
			/>
		</>
	);
};

DefaultColumnFilter.propTypes = {
	column: PropTypes.shape( {
		filterValue: PropTypes.string,
		id: PropTypes.string,
		preFilteredRows: PropTypes.array,
		setFilter: PropTypes.func,
		setTableState: PropTypes.func
	} )
};

export default memo( DefaultColumnFilter );
